import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { crmWhatsAppApi } from '../../api/crmApi';
import TemplateManager from './components/TemplateManager';
import './CRM.css';

const fallbackTemplates = [
  { id: 1, name: 'Welcome', category: 'General', language: 'en', status: 'Active', content: 'Hello {{customer_name}}, welcome to CTMS! We supply quality gas cylinders at the best prices. Reply to this chat for any enquiries. — {{salesperson_name}}' },
  { id: 2, name: 'Lead Follow-up', category: 'Lead Follow-up', language: 'en', status: 'Active', content: 'Hi {{customer_name}}, this is {{salesperson_name}} following up on your enquiry for gas cylinders. Would you like me to share a quotation? — CTMS' },
  { id: 3, name: 'Quotation', category: 'Quotation', language: 'en', status: 'Active', content: 'Dear {{customer_name}}, your quotation {{quotation_number}} for {{quotation_amount}} is ready. Please review and confirm to proceed. — CTMS' },
  { id: 4, name: 'Quotation Reminder', category: 'Quotation Reminder', language: 'en', status: 'Active', content: 'Hi {{customer_name}}, gentle reminder — quotation {{quotation_number}} is awaiting your confirmation. Offer valid till {{followup_date}}. — CTMS' },
  { id: 5, name: 'Payment Reminder', category: 'Payment Reminder', language: 'en', status: 'Active', content: 'Dear {{customer_name}}, this is a gentle reminder for your pending payment of {{quotation_amount}}. Kindly process at the earliest. — CTMS Accounts' },
  { id: 6, name: 'Product Information', category: 'Product Information', language: 'en', status: 'Draft', content: 'Hi {{customer_name}}, our new range of industrial gas cylinders is now available with 40% longer life. Reply INTEREST for the catalogue. — CTMS' },
  { id: 7, name: 'Welcome (Hindi)', category: 'Welcome', language: 'hi', status: 'Active', content: 'नमस्ते {{customer_name}}, CTMS में आपका स्वागत है! गैस सिलेंडर की सर्वोत्तम कीमतों के लिए हमसे संपर्क करें। — {{salesperson_name}}' },
];

export default function CRMTemplates() {
  const [templates, setTemplates] = useState(fallbackTemplates);
  const [loading, setLoading] = useState(true);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await crmWhatsAppApi.getTemplates({ size: 200 });
      const d = Array.isArray(res.data) ? res.data : res.data?.content;
      if (d?.length) setTemplates(d);
    } catch { /* fallback */ } finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const save = async (t) => {
    try {
      if (fallbackTemplates.some((x) => x.id === t.id)) {
        if (t.id <= 1000) await crmWhatsAppApi.updateTemplate(t.id, t);
        else await crmWhatsAppApi.createTemplate(t);
      } else {
        await crmWhatsAppApi.createTemplate(t);
      }
      toast.success('Template saved.');
    } catch { toast.info('Saved locally — CRM API not reachable.'); }
  };

  const remove = async (id) => {
    try { await crmWhatsAppApi.deleteTemplate(id); } catch { /* ignore */ }
    toast.success('Template deleted.');
  };

  return (
    <div className="crm-page">
      <TemplateManager templates={templates} loading={loading} onSave={save} onDelete={remove} />
    </div>
  );
}
